export default __webpack_public_path__ + "static/media/public_sector.74d9b338.jpg";